import { type AlertBanner, AlertState } from '@generated/graphql';
import { deepOmit } from '@utils/deepOmit';
import { AlertBannerStatus } from './types';

export const getAlertBannerMutationInput = (
  alertBannerFields: Partial<AlertBanner>,
) => {
  const fields = deepOmit(alertBannerFields, [
    '__typename',
  ]) as Partial<AlertBanner>;

  return {
    name: fields.name,
    bannerType: fields.bannerType,
    bannerCopy: fields.bannerCopy,
    configuration: fields.configuration,
    persistenceBehaviour: fields.persistenceBehaviour,
    actionButton: fields.actionButton,
    startDate: fields.startDate,
    endDate: fields.endDate,
    roleProfiles: fields.roleProfiles?.map((roleProfile) => roleProfile.id),
  };
};

export const getAlertBannerStatus = (
  state: AlertState,
  startDate?: string | null,
  endDate?: string | null,
) => {
  if (state === AlertState.Draft) {
    return AlertBannerStatus.DRAFT;
  }

  const now = new Date();
  // biome-ignore lint/style/noNonNullAssertion: startDate required for PUBLISHED banners
  const startDateObj = new Date(startDate!);
  // biome-ignore lint/style/noNonNullAssertion: endDate required for PUBLISHED banners
  const endDateObj = new Date(endDate!);

  if (now < startDateObj) {
    return AlertBannerStatus.SCHEDULED;
  } else if (now > endDateObj) {
    return AlertBannerStatus.EXPIRED;
  } else {
    return AlertBannerStatus.ACTIVE;
  }
};
